import React from "react";
import Blog_57 from "../component/Blog_57";

function Blog_57_container() {
  return <Blog_57 />;
}

export default Blog_57_container;
